import { Update } from '@ngrx/entity';
import { createAction, props } from '@ngrx/store';
import { TaxClassification } from '@src/app/secure/terms/components/backup-withholding/backup-withholding.component';
import { TransactionState } from '@store/index';

export const AddStateToTransactions = createAction(
  '[AdaptedState] Add State',
  props<{ state: TransactionState }>(),
);

export const UpdateTransactionState = createAction(
  '[AdaptedState] Update State',
  props<{ update: Update<TransactionState> }>(),
);

export const DeleteTransactionState = createAction(
  '[AdaptedState] Delete State',
  props<{ id: string }>(),
);

export const LoadTransactionStates = createAction(
  '[AdaptedState] Load States',
  props<{ states: TransactionState[] }>(),
);

export const ClearTransactionStates = createAction('[AdaptedState] Clear States');

export const SetTransactionId = createAction(
  '[TransactionId] Set transaction id',
  props<{ id: string }>(),
);

export const SetTransactionAsCurrent = createAction(
  '[AdaptedState] Set transaction as current',
  props<{ transaction: TransactionState }>(),
);

export const ClearCurrentTransactionState = createAction(
  '[AdaptedState] Clear current transaction state',
);

export const SetTransactionReviewPageEditMode = createAction(
  '[AdaptedState] Set transaction review page edit mode',
  props<{ isReviewPageReachedAndEditMode: boolean }>(),
);

export const SetTransactionOAReviewPageEditMode = createAction(
  '[AdaptedState] Set transaction OA review page edit mode',
  props<{ isOAReviewPageReachedAndEditMode: boolean }>(),
);

export const SetTransactionReviewInvestmentObjectivesMode = createAction(
  '[AdaptedState] Set transaction review investment objectives mode',
  props<{ isMultiReviewPageReachedAndSkipInvestmentRevision: boolean }>(),
);

export const CreateNewTransaction = createAction(
  '[AdaptedState] Create New Transaction',
  props<{ currentTransactionEditMode?: boolean }>(),
);

export const StampDraftOnTransaction = createAction(
  '[AdaptedState] Stamp Draft On Transaction',
  props<{ transactionId: string; draftId: string; draftSequence: number }>(),
);

export const SetBackupWithholdingSignatureName = createAction(
  '[AdaptedState] Set Backup Withholding Signature Name',
  props<{
    taxClassification: TaxClassification;
    signatureName: string;
    trustName?: string;
    ein?: string;
    grantorSsn?: string;
    estateName?: string;
    tin?: string;
  }>(),
);

export const SetBackupWithholdingAnswer = createAction(
  '[AdaptedState] Set Backup Withholding Answer',
  props<{ taxClassification: TaxClassification; withholdingAnswer: 'yes' | 'no' }>(),
);
